import { LOAD_DASHBOARD_SUCCESS} from "actions/dashboardActions";
import { LOAD_DASHBOARD_SUCCESS_PP} from "actions/dashboardActionsPP";
import { SUBMIT_CHARITY_SURVEY_SUCCESS } from "actions/charityActions";
import * as widgetTypes from "components/dashboard/widgets/WidgetTypes";
import { assocPath } from "ramda";

const initialState = {
  loading: true,
  all: [],
  byId: {},
  pageFieldsById: {},
  dashboardData: null
};

const eCommerceTransformer = ({ products: { product }, ...rest }) =>
  assocPath(["products"], [].concat(product), rest);

// Standardized data from object to array
const transformData = ({ id, content }) => {
  if (id === widgetTypes.ECOMMERCE) {
    return eCommerceTransformer(content);
  }

  return content;
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_DASHBOARD_SUCCESS: {
      return {
        ...state,
        loading: false,
        byId: action.payload.cards.reduce(
          (obj, item) => ({ ...obj, [item.id]: transformData(item) }),
          {}
        ),
        all: action.payload.cards.map(item => item.id),
        pageFieldsById: action.payload.cards.reduce(
          (obj, item) => ({
            ...obj,
            [item.id]: item.pageFields ? item.pageFields : null,
          }),
          {}
        ),
      };
    }
    case LOAD_DASHBOARD_SUCCESS_PP: {
      return {
        ...state,
        loading: false,
        dashboardData: action.payload
      };
    }
    case SUBMIT_CHARITY_SURVEY_SUCCESS: {
      return {
        ...state,
        loading: false,
        byId: { ...state.byId, ...action.payload },
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./reducers/dashboardReducer.js